/**
 * @generated SignedSource<<1109478e79169382a1f3216330fe3ea6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CityWalk_cityWalk",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapContextProvider_map"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CityWalkLayout_cityWalk"
        }
      ],
      "type": "CityWalk",
      "abstractKey": null
    }
  ],
  "type": "ParticipativeModuleVisualization",
  "abstractKey": "__isParticipativeModuleVisualization"
};

node.hash = "394b041673442aca706fd94823deba9f";

module.exports = node;
